import { render, staticRenderFns } from "./YPanelMsg.vue?vue&type=template&id=54187022&scoped=true"
import script from "./YPanelMsg.vue?vue&type=script&lang=js"
export * from "./YPanelMsg.vue?vue&type=script&lang=js"
import style0 from "./YPanelMsg.vue?vue&type=style&index=0&id=54187022&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54187022",
  null
  
)

export default component.exports